import { useEffect, useState } from 'react'; 
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';

import { useAuth } from '../../auth'

import * as choiceApi from '../../api/choice';

import './SpecialAnnouncements.css';

export function SpecialAnnouncements() {
    let { user } = useAuth();
    const [announcements, setAnnouncements] = useState([]);
    const [show, setShow] = useState(true);

    useEffect(() => {
        let isMounted = true;
        async function loadAnnouncements() {
            const newAnnouncements = await choiceApi.getAnnouncements();
            if (isMounted) {
                setAnnouncements(newAnnouncements);
            }
        }

        loadAnnouncements();
        return () => isMounted = false;
    }, [user])


    if (show) {
        return (
            <Container className="announcement-collection">
                <Alert onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Special Announcements</Alert.Heading>
                    {announcements.map((x, i) => <div key={i} className="announcement">
                        <div className="posted">Posted: {new Date(x.startDate).toLocaleDateString()}</div>
                        {x.msg}
                    </div>)}
                </Alert>
            </Container>
        )
    }
    else {
        return null;
    }

}